import Button from '../../components/ui/Button/Button';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__wrap">

        <div className="hero__top">
          <span className="hero__kicker">Real Estate Development · Lagos</span>
          <div className="hero__top-actions">
            <Button href="/#projects" variant="dark">Explore Developments</Button>
            <Button href="/#contact" variant="outline">Get in Touch</Button>
          </div>
        </div>

        <h1 className="hero__h1">
          Building<br />
          Premium Residential<br />
          <em>Communities.</em>
        </h1>

        <div className="hero__bottom">
          <p className="hero__p">
            NimbleCasa develops modern, high-quality residential projects
            across Lagos — delivering thoughtfully designed living spaces
            and strong investment returns for buyers and investors.
          </p>
        </div>

      </div>
    </section>
  );
}
